export default __webpack_public_path__ + "static/media/GE.88686223.svg";